import { render, staticRenderFns } from "./SubNav.vue?vue&type=template&id=1b0a071d&scoped=true&"
import script from "./SubNav.vue?vue&type=script&lang=js&"
export * from "./SubNav.vue?vue&type=script&lang=js&"
import style0 from "./SubNav.vue?vue&type=style&index=0&id=1b0a071d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0a071d",
  null
  
)

export default component.exports